export function callAppShare(appShareConfigUser) {
  // app内分享和保存图片
  const appShareConfig = {
    shareType: 1, // 1.网页，2大图，3小程序
    wxMiniId: 'gh_f95e210b8eb3', // 原始id
    wxMiniPath: '',
    wxMiniProgramType: 0, // 正式版：0  测试版：1  体验版：2
    shareScence: 5, // // 1 微信 2 微信朋友圈 3 qq好友 4 qq空间 5 复制链接 32 保存图片
    isOneKeyShare: true, // 是否一键分享
    title: '学而思网校',
    iconUrl: 'https://activity.xueersi.com/topic/growth/common/images/common/xes-logo.png',
    desc: '好友邀你上名师课，注册即可领取' // 分享描述
  }
  Object.assign(appShareConfig, appShareConfigUser)
  const fun = () => {
    window.userInfoappShareBack = async res => {
      console.log('xesShare/share===========', res)
    }
    // console.log('JSON.stringify(appShareConfig)', JSON.stringify(appShareConfig), appShareConfig.shareScence)
    window.xesApp.start('xesShare/share', JSON.stringify(appShareConfig), 'userInfoappShareBack')
  }
  if (appShareConfig.shareScence === 32 || appShareConfig.shareScence === 2) {
    window.h5SavePoster = res => {
      // console.log('res======', res)
      appShareConfig.imageLocalPath = res
      fun()
    }
    const imgData = appShareConfig.imgData
    window.xesApp.saveImageWithBase64(
      imgData,
      'sharePoster-' + appShareConfig.shareType + '.png',
      'h5SavePoster '
    )
  } else {
    fun()
  }
}
export function setAppTitleBar({ title = '', icon = '', scrolledIcon = '' } = {}, cb = null) {
  console.log('setAppTitleBar')
  const params = {
    title,
    action_icon: icon || 'https://editor.xesimg.com/tailor/resource/fx4-1623223652680.png',
    action_icon_scrolled: scrolledIcon || ''
  }
  window.callbackSetTitleBar = () => {
    typeof cb === 'function' && cb()
  }
  console.log(xesApp)
  window.xesApp.start('setTitleBar', JSON.stringify(params), 'callbackSetTitleBar')
}
